import DosingRow from 'components/DosingRow/DosingRow';
import DosingTitle from 'forms/DosingInfo/DosingTitle/DosingTitle';

const FixedDosing = () => {
  return (
    <div
      className="tab-pane dosing-form-container"
      id="pills-fixed"
      role="tabpanel"
      aria-labelledby="pills-fixed-tab"
      tabIndex={0}
    >
      <DosingTitle title="Fixed XYREM Dosing" />

      <DosingRow
        fields={{
          doses: ['rems:fixedDosing:dose:1', 'rems:fixedDosing:dose:2'],
          totalDose: 'rems:fixedDosing:dose:total',
        }}
        withOperators
        wideField
        mobileFullWidth
      />
    </div>
  );
};

export default FixedDosing;
